// src\pages\Marketplace\Autocitymag\AutocitymagPage.tsx

export const AutocitymagPage = () => {
    return (
        <div className="p-4">
            Auto City Magazine Page
        </div>
    )
}

export default AutocitymagPage